import { render } from "./photoContent.vue?vue&type=template&id=b3e6c4a2&scoped=true"
import script from "./photoContent.vue?vue&type=script&lang=js"
export * from "./photoContent.vue?vue&type=script&lang=js"

import "./photoContent.vue?vue&type=style&index=0&id=b3e6c4a2&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e6c4a2"]])

export default __exports__